import ajax from './../ajax';

export function getAllSeminars() {
  return ajax('/seminars', {
    method: 'GET'
  });
}

export function seminarAudience(params) {
  return ajax('/seminar_audiences', {
    method: 'POST',
    body: {
      seminar_audience: {
        ...params
      }
    }
  });
}

export function seminarRazorpayOrders(params) {
  return ajax('/seminar_razorpay_orders', {
    method: 'POST',
    body: {
      seminar_razorpay_order: {
        ...params
      }
    }
  });
}

export function seminarRegistrations(params) {
  return ajax('/seminar_registrations', {
    method: 'POST',
    body: {
      seminar_registration: {
        ...params
      }
    }
  });
}

export function getWorkshopsById() {
  return ajax('/get_workshops_by_ids', {
    method: 'GET'
  });
}



// WEBPACK FOOTER //
// ./src/api/v1/seminars.js